import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { RootScopeService } from 'src/app/core/services/root-scope.service';
import { environment } from 'src/environments/environment';
import DocumentStatsResponse from 'src/models/DocumentStatsResponse';

@Injectable({
  providedIn: 'root'
})
export class DetailsService {
  constructor(private http: HttpClient, private rootScope: RootScopeService) { }

  // dates are "YYYY-MM-DD HH:mm:ss" UTC, the format date_of_upload is stored in
  getDocumentStats(customer_cd: string, start_date: string, end_date: string,
                   last_seen_id?: string | null, last_seen_date?: string | null): Observable<DocumentStatsResponse> {
    let url = environment.server.concat('/document_stats');
    url = url.concat(`/?customer_cd=${encodeURIComponent(customer_cd)}`);
    url = url.concat(`&&start_date=${encodeURIComponent(start_date)}&&end_date=${encodeURIComponent(end_date)}`);
    const source = this.rootScope.globals.source;
    if (source != undefined) {
      url = url.concat(`&&source=${encodeURIComponent(source)}`);
    }
    if (last_seen_id != undefined && last_seen_date != undefined) {
      url = url.concat(`&&last_seen_id=${encodeURIComponent(last_seen_id)}&&last_seen_date=${encodeURIComponent(last_seen_date)}`);
    }
    return this.http.get<DocumentStatsResponse>(url, { observe: 'response' }).pipe(
      map((response: any) => response.body)
    );
  }
}
